import Component from 'gia/Component'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);



class Menu extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.index = 0

    this.ref = {
      buton: null
    }

  }

  mount() {

     _each($('[data-color]'), (el, i) => {
         
      
         let start = "top 1%"
         ScrollTrigger.create({
             trigger: el,
             start: start,
             id: `id${i}`,

             onToggle: (self) => {
                 $('body').toggleClass(`menu-color-${el.dataset.color}`)
             }
         });
     })

     _each($('[data-volume]'), (el, i) => {


       let start = "top bottom"
       ScrollTrigger.create({
         trigger: el,
         start: start,
         id: `ids${i}`,
         end: 'bottom bottom',

         onToggle: (self) => {
          console.log('toggle');
           $('body').toggleClass(`volume-${el.dataset.volume}`)
         }
       });
     })

     $(this.ref.buton).on('click', (e) => {
      
       $('body').toggleClass('has-menu')
     })

     $('.menu a').on('click', (e) => {

       $('body').removeClass('has-menu')
     })



     

    
 }

 removeClassByPrefix(node, prefix) {
   var regx = new RegExp('\\b' + prefix + '[^ ]*[ ]?\\b', 'g');
   node.className = node.className.replace(regx, '');
   return node;
 }

 


  unmount() {

    _each($('[data-color]'), (el, i) => {
      ScrollTrigger.getById(`id${i}`).kill();
     
    })

     _each($('[data-volume]'), (el, i) => {
       ScrollTrigger.getById(`ids${i}`).kill();

     })

    

    $(this.ref.buton).off('click')
  }


}

module.exports = Menu
